








































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {mapGetters} from "vuex";

import Feed from "@/components/timeline/_feed.vue";
import Portfolio from "@/components/pages/user/PortfolioList.vue";


import Timeline from "@/components/timeline/_timeline.vue"

import {User} from "@/types";
import {AxiosError, AxiosResponse} from "axios";

@Component({
    computed: {...mapGetters(["user"])},
    components: {
        Feed,
        Portfolio,
        Timeline
    },
})
export default class UserPage extends Vue {
    channel_id = this.$route.params.channel_id;
    games: any[] = [];
    totalGameCnt = 0;
    user!: any;
    communityList: {
        id: number;
        name: string;
        profile_img: string;
        state: string;
        member_cnt: number;
    }[] = [];
    userId = 0;

    async mounted() {
        await this.$store.dispatch("loginState");
        this.gameListFetch();

    }

    gameListFetch() {
        this.$api.userChannel(this.channel_id)
            .then((res: any) => {
                const {target} = res;
                const {games} = target;
                this.userId = target.id
                this.$store.commit('gameList', games)
                if (games.length > 0) {
                    this.totalGameCnt = games.length;
                }

                this.games = games.slice(0, 5)
                this.communityFetch();
            })
            .catch((err: AxiosError) => {
                // this.$router.push(`/${this.$i18n.locale}`)
                // console.log('err', err)
            })


    }

    communityFetch() {
        this.$api.joinedCommunityList(this.userId)
            .then((res: any) => {
                this.communityList = res;
            })
            .catch((err: AxiosError) => {
                this.$router.push(`/${this.i18n.locale}`)
            })


    }

    moveGameChannel(gamePath: string) {
        this.$router.push(`/${this.$i18n.locale}/timeline/game/${gamePath}`);
    }

    moveGroupPage(id: any) {
        this.$router.push(`/${this.$i18n.locale}/community/${id}/timeline`);
    }

    playGame(pathname: string) {
        window.open(
            this.$store.getters.homeUrl + `play/${pathname}`, "_blank");
    }


}
